import React from "react";
import { Box, FormGroup, Button } from "@mui/material";
import ChoiceItem from "../ChoiceItem";

function MultiChoiceQuestion({ question, index, handleChoiceChange, handleAddChoice, enqueueSnackbar }) {
  const handleRemoveChoice = (questionIndex, choiceIndex) => {
    // Prevent removing if there are 2 or fewer choices (validation requires at least 2)

     if (question.choices.length <= 4) {
      enqueueSnackbar("Multi-choice questions must have at least four choices.", {
        variant: "warning",
        autoHideDuration: 2000,
        anchorOrigin: { vertical: "bottom", horizontal: "right" },
      });
      return;
    }

    const updatedChoices = question.choices.filter((_, idx) => idx !== choiceIndex);
    handleChoiceChange(questionIndex, null, "choices", updatedChoices);
  };

  return (
    <>
      <FormGroup>
        {question.choices.map((choice, choiceIndex) => (
          <ChoiceItem
            key={choiceIndex}
            choice={choice}
            choiceIndex={choiceIndex}
            questionIndex={index}
            handleChoiceChange={handleChoiceChange}
            handleRemoveChoice={handleRemoveChoice}
            isMultiChoice={true}
          />
        ))}
      </FormGroup>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          onClick={() => handleAddChoice(index)}
          variant="outlined"
          size="small"
          sx={{
            textTransform: "none",
            color: "#1976d2",
            borderColor: "#1976d2",
            borderRadius: "4px",
            fontSize: "0.875rem",
            fontWeight: "medium",
            px: 2,
            py: 0.5,
            "&:hover": {
              backgroundColor: "rgba(25, 118, 210, 0.04)",
              borderColor: "#1976d2",
            },
          }}
        >
          Add a Choice
        </Button>
      </Box>
    </>
  );
}

export default MultiChoiceQuestion;
